import {
  CAMPAIGN_MESSAGE_TEMPLATE_LIMITS,
  type CampaignAudienceMode,
  type CampaignChannelKind,
  type CampaignDeliveryMode,
  type CampaignPurpose,
} from '@workspace/types';

const STORAGE_KEY = 'ca-campaign-wizard';
const MAX_BYTES = 12000;

export type CampaignWizardSnapshot = {
  name: string;
  agentId: string;
  channelId: string;
  purpose: CampaignPurpose;
  deliveryMode: CampaignDeliveryMode;
  channelKind: CampaignChannelKind;
  messageTemplateId: string;
  audienceMode: CampaignAudienceMode;
  maxContactsPerDay: number;
  autoReplyText: string;
  retryTemplateId?: string;
  retryWaitHours?: number;
  endsAtDate?: string;
};

export function saveCampaignWizardSnapshot(snapshot: CampaignWizardSnapshot): void {
  const payload = JSON.stringify(snapshot).slice(0, MAX_BYTES);
  sessionStorage.setItem(STORAGE_KEY, payload);
}

export function loadCampaignWizardSnapshot(): CampaignWizardSnapshot | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)?.slice(0, MAX_BYTES);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as Partial<CampaignWizardSnapshot>;
    if (typeof parsed.name !== 'string') {
      return null;
    }
    return {
      name: parsed.name.slice(0, 255),
      agentId: String(parsed.agentId ?? '').slice(0, 64),
      channelId: String(parsed.channelId ?? '').slice(0, 64),
      purpose: parsed.purpose === 'AVISO' ? 'AVISO' : 'COBRANZAS',
      deliveryMode: parsed.deliveryMode === 'NOTIFICATION' ? 'NOTIFICATION' : 'CONVERSATIONAL',
      channelKind:
        parsed.channelKind === 'SMS' || parsed.channelKind === 'EMAIL' ? parsed.channelKind : 'WHATSAPP',
      messageTemplateId: String(parsed.messageTemplateId ?? '').slice(0, 64),
      audienceMode: parsed.audienceMode === 'EXPLICIT' ? 'EXPLICIT' : 'SEGMENT',
      maxContactsPerDay: Number(parsed.maxContactsPerDay) || 100,
      autoReplyText: String(parsed.autoReplyText ?? '').slice(0, CAMPAIGN_MESSAGE_TEMPLATE_LIMITS.autoReplyMax),
      retryTemplateId: String(parsed.retryTemplateId ?? '').slice(0, 64),
      retryWaitHours: Number(parsed.retryWaitHours) || 24,
      endsAtDate: String(parsed.endsAtDate ?? '').slice(0, 10),
    };
  } catch {
    return null;
  }
}

export function clearCampaignWizardSnapshot(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
